module.exports = __webpack_public_path__ + "static/img/tem.67d0466e.png";